import { render, staticRenderFns } from "./sfc-star-rating.vue?vue&type=template&id=66d42712&scoped=true&lang=pug&"
import script from "./sfc-star-rating.vue?vue&type=script&lang=js&"
export * from "./sfc-star-rating.vue?vue&type=script&lang=js&"
import style0 from "./sfc-star-rating.vue?vue&type=style&index=0&id=66d42712&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d42712",
  null
  
)

export default component.exports